const IP = {
    // host: 'http://192.168.31.182:8734', //刚
    // host: 'https://172.22.63.168:8734', //苗
    // host: 'https://xiaoxi.huanghuai.edu.cn:8734',
    // host: 'http://ssjs.huanghuai.edu.cn',
    // host: 'https://211.67.177.173:8734',
    host: 'https://ssjs.huanghuai.edu.cn:8734',
    appId: 'wx75a7d7dc98a01503',
    wxredirect: 'https://ssjs.huanghuai.edu.cn',
    // wxredirect: 'http://ssjs.huanghuai.edu.cn',
    key:"9dEA20JIHLppdq1E",// 16位
    iv:"0000000000000000",// 16位
};
export default IP
